<template>
  <div class="h-1 w-full">
    <div class="absolute h-1 animate-[borealisBar_0.5s_linear_infinite] bg-primary-tints-500" />
  </div>
</template>

<style>
@keyframes borealisBar {
  0% {
    left:0%;
    right:100%;
    width:0%;
  }
  10% {
    left:0%;
    right:75%;
    width:25%;
  }
  90% {
    right:0%;
    left:75%;
    width:25%;
  }
  100% {
    left:100%;
    right:0%;
    width:0%;
  }
}
</style>
